module.exports = __webpack_public_path__ + "static/media/smoking.c1a93bd0.svg";